var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "YouTube",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 19,
    height: 14,
    rx: 4,
    fill: "none",
    stroke: "#C8D2E0",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 9 6 3-6 3Z",
    fill: "#C8D2E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusFooterYoutube);
export default __webpack_public_path__ + "static/media/andus-footer-youtube.c87a53a1e6f1089d9f936e11cd7660d9.svg";
export { ForwardRef as ReactComponent };